import { Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/styles";
import React from "react";

/**
 * ClinicianDetailItem component renders an icon and formatted text.
 * The text can contain parts wrapped in asterisks (*) which will be styled differently.
 *
 * @param {Object} props - The component props.
 * @param {React.ElementType} props.Icon - The icon component to be rendered.
 * @param {string} props.text - The text to be displayed, with parts to be styled wrapped in asterisks (*).
 * @returns {JSX.Element} The rendered ClinicianDetailItem component.
 */
export default function ClinicianDetailItem({ Icon, text, iconProps }) {
  const theme = useTheme();
  const formatText = (text) => {
    // Split by * and map through parts
    return text.split(/\*(.+?)\*/).map((part, index) => {
      // Every odd index is between ** and should be styled
      if (index % 2 === 1) {
        return (
          <span key={index} style={{ color: theme.palette.primary.main, fontWeight: 500 }}>
            {part}
          </span>
        );
      }
      return part;
    });
  };
  return (
    <Stack direction="row" alignItems="center" gap={3}>
      <Icon
        size={16}
        style={{ flexShrink: 0 }}
        color={theme.palette.action.active}
        {...iconProps}
      />
      <Typography color="text.secondary" variant="caption">
        {formatText(text)}
      </Typography>
    </Stack>
  );
}
